<template>
  <div class="formCom">
    <Personal
      v-if="show === 'personal'"
      @closeProfile="closeProfile"
      @changeModal="changeModal"
    ></Personal>
    <Password
      v-if="show === 'password'"
      @closeProfile="closeProfile"
      @show="chancgeCom"
    ></Password>
  </div>
</template>

<script>
import Personal from "./profile/Personal";
import Password from "./profile/Password";

export default {
  name: "Profile",
  data() {
    return {
      show: "personal"
    };
  },
  components: {
    Password,
    Personal
  },
  methods: {
    changeModal(val) {
      this.show = val;
    },
    chancgeCom(txt) {
      this.show = txt;
    },
    closeProfile(boolean) {
      this.$emit("closeProfile", boolean);
    }
  }
};
</script>

<style scoped>
.formCom {
  /*background-color: rgba(219, 230, 241, 0.5);*/
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
@media (max-width: 1024px) {
  .formCom {
    align-items: flex-start;
  }
}
</style>
